






import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import LocationPanelState from '@/mixins/LocationPanelState';

@Component
export default class LocationPanelMobileNavItem extends mixins(LocationPanelState) {
    private handleMenuState(): void {
        if (this.isActiveItem) {
            this.toggleMobileMenu();

            return;
        }
        this.setActiveLocationPanelItem(this.id);
        this.isAboutItem ? this.setActiveMarkerCategory(null) : this.setActiveMarkerCategory(this.id);
    }
}

